export default {
    title_list: 'QR Codes',
    title_page: 'QR Code',
    title_create_page: 'Create QR code',
    title_edit_page: 'Change QR code',

    filter: {
        labels: {
            code: 'Code',
            note: 'Note',
        }
    },

    table: {
        labels: {
            id: 'ID',
            hash: 'Code',
            note: 'Note',
            label_size: 'Label Size',
            pages: 'Pages',
            print_border: 'Print Border',
            artifact_id: 'Artifact',
            activated_at: 'Activated at',
            created_at: 'Created at',
        }
    },

    buttons: {
        export: 'Export',
        generate: 'Generate code',
        generateQRCode: 'Generate QR codes',
    },

    form: {
        hash: 'Code',
        user_id: 'Member',
        artifact_id: 'Artifact',
        activated_at: 'Activated at',
    },
}
